import { id_pkix } from "@peculiar/asn1-x509";
export const id_pe_logotype = "1.3.6.1.5.5.7.1.12";
export const id_logo = `${id_pkix}.20`;
export const id_logo_loyalty = `${id_logo}.1`;
export const id_logo_background = `${id_logo}.2`;
export const id_logo_certImage = `${id_logo}.3`;
